/* UPLIFT cart-drawer checkout CTA — always-on.
   Replaces the native checkout button text (e.g. "BETALING", from content.checkout)
   with "Gå til kassen — <live total>". The native total line is hidden by the trust
   snippet CSS, so the total lives in the button. Loaded unconditionally from
   cart-drawer.liquid so it works even when the page loaded with an empty cart
   (the old {% javascript %} approach only ran if the drawer summary was present at
   page load, which broke the button whenever the cart started empty).

   Currency: Horizon renders the cart total with the ISO code ("899 NOK") because the
   store enabled currency_code_enabled_cart_total, but product/line prices use the
   symbol ("899 kr"). To match the line prices (and stay correct per market: SEK->kr,
   EUR->€, GBP->£), we swap the ISO code in the total for the symbol scraped from a
   line-item price. */
(function () {
  if (window.__upliftCartCTA) return;
  window.__upliftCartCTA = 1;
  // Translated label ('uplift.cart_cta.checkout' | t) from a data-uplift-cart-cta-label attribute
  // (on this script tag in snippets/cart-drawer.liquid); English only if missing.
  function label() {
    var src = document.querySelector('[data-uplift-cart-cta-label]');
    return (src && src.getAttribute('data-uplift-cart-cta-label')) || 'Checkout';
  }
  function symbol() {
    var el = document.querySelector('#cart-drawer .cart-items__price, #cart-drawer .cart-item__price, #cart-drawer .price');
    if (!el) return '';
    var m = el.textContent.replace(/ /g, ' ').match(/[^\d.,\s]+/g);
    return m ? m[m.length - 1].trim() : '';
  }
  function money() {
    var el = document.querySelector('#cart-drawer [data-testid="cart-total-value"]');
    if (!el) { if (window.Shopify && window.Shopify.designMode) console.warn('[uplift-cart-cta] [data-testid=cart-total-value] not found — Horizon may have renamed it; button total skipped (label still shows).'); return ''; }
    var raw = el.textContent.replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
    if (!raw) return '';
    var sym = symbol();
    if (sym) {
      // Total may arrive as ISO only ("76 GBP"), symbol+ISO ("£76.00 GBP"), or symbol
      // only. If a symbol is already present, just drop the ISO code (avoids "£76 £").
      if (raw.indexOf(sym) !== -1) raw = raw.replace(/[A-Z]{3}/, '');
      else raw = raw.replace(/[A-Z]{3}/, sym);
      raw = raw.replace(/\s+/g, ' ').trim();
    }
    // Drop a whole-number decimal (",00" / ".00") so the total matches the no-decimal line prices.
    // Horizon renders the cart total with money_with_currency, which keeps 2 decimals on presentment
    // currencies (SEK/DKK/EUR/…) — there's no trailing-zeros variant of that filter, so strip here.
    // Keeps a genuine fractional total (e.g. ",50") intact, mirroring money_without_trailing_zeros.
    raw = raw.replace(/([.,])(\d{2})(\s*\S*)$/, function (_, sep, dec, tail) { return dec === '00' ? tail : sep + dec + tail; });
    return raw;
  }
  function apply() {
    var btn = document.querySelector('#cart-drawer .cart__checkout-button .button-text');
    if (!btn) return;
    var total = money();
    var LABEL = label();
    var want = total ? (LABEL + ' — ' + total) : LABEL;
    if (btn.textContent.replace(/\s+/g, ' ').trim() !== want) btn.textContent = want;
  }
  function boot() {
    var root = document.getElementById('cart-drawer');
    if (!root) return;
    apply();
    if (window.MutationObserver) {
      new MutationObserver(apply).observe(root, { childList: true, subtree: true, characterData: true });
    }
    document.addEventListener('shopify:section:load', apply);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
